import React, {useEffect} from 'react';
import {inject, observer} from 'mobx-react';
import TimeToStartTimer from 'app/utils/TimeToStartTimer';
import {CurrentTimeStore} from 'stores/current_time_store';
import {SEC_IN_DAY} from 'app/utils/Consts';

interface CasinoTournamentTimerProps {
    promotionEndTime: number
    onExpire: () => void
    currentTimeStore?: CurrentTimeStore
}

const CasinoTournamentTimer = (
    {promotionEndTime, currentTimeStore, onExpire}: CasinoTournamentTimerProps
): React.ReactElement => {
    const isExpired = promotionEndTime > 0 && promotionEndTime - currentTimeStore.t < 0;
    const showDays = promotionEndTime - currentTimeStore.t >= SEC_IN_DAY;

    useEffect(() => {
        if (isExpired && onExpire) {
            onExpire();
        }
    }, [isExpired, onExpire]);

    return <span className="casino-tournament__timer">
        <TimeToStartTimer time_to_start={promotionEndTime} showOnlyDays={showDays}/>
    </span>;
};

export default inject('currentTimeStore')(observer(CasinoTournamentTimer));
